import { PROJECTS_QUERY_CONTEXT_PREFIX } from './constants';

export function makeProjectsQueryContextKey() {
  return `${PROJECTS_QUERY_CONTEXT_PREFIX}_projects`;
}
